"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _has2 = _interopRequireDefault(require("lodash/has"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var getShipRecRequest = function getShipRecRequest(deliveryRequest, plan) {
  var shipRecRequest = (0, _get2["default"])(plan, 'shipRecRequest');

  if (!shipRecRequest) {
    return undefined;
  }

  shipRecRequest.shippingDestination = {};

  if ((0, _get2["default"])(deliveryRequest, '_links.pickupPoint')) {
    shipRecRequest.shippingDestination.pickupPointUrl = (0, _get2["default"])(deliveryRequest, '_links.pickupPoint.href');
  } else {
    var destinationAddress = deliveryRequest.destinationAddress;
    shipRecRequest.shippingDestination.address = {
      postalCode: destinationAddress.postalCode,
      countryCode: destinationAddress.country,
      locality: destinationAddress.city
    };

    if (destinationAddress.street1 && destinationAddress.street1 !== '') {
      shipRecRequest.shippingDestination.address.street = destinationAddress.street1;
    }

    if (destinationAddress.street2 && destinationAddress.street2 !== '') {
      shipRecRequest.shippingDestination.address.street2 = destinationAddress.street2;
    }

    if (destinationAddress.stateOrProvince && destinationAddress.stateOrProvince !== '') {
      shipRecRequest.shippingDestination.address.region = destinationAddress.stateOrProvince;
    }

    if ((0, _has2["default"])(destinationAddress, 'isResidential')) {
      shipRecRequest.shippingDestination.address.addressType = /^true$/i.test(destinationAddress.isResidential) ? 'residential' : 'commercial';
    }
  }

  return shipRecRequest;
};

var _default = getShipRecRequest;
exports["default"] = _default;